import { useState } from 'react';
import type { SystemAnnouncement } from '@forq/contracts';
import { AnnouncementDialog } from '@forq/ui';
import { rememberAnnouncementSeen, shouldShowAnnouncement } from './announcementSeen';

interface AnnouncementGateProps {
  readonly announcement: SystemAnnouncement | null;
}

/**
 * Entscheidet, OB die Systemmeldung beim Start erscheint -- das Aussehen macht der geteilte
 * AnnouncementDialog, damit die Vorschau im Adminpanel dasselbe zeigt.
 *
 * Der Zustand wird bewusst nur einmal beim Mounten berechnet: waere es ein useEffect auf
 * `announcement`, koennte eine Meldung mitten in der Arbeit aufspringen, weil irgendwo neu
 * geladen wurde. "Beim Start" heisst beim Start.
 */
export function AnnouncementGate({ announcement }: AnnouncementGateProps) {
  const [open, setOpen] = useState(() => shouldShowAnnouncement(announcement));
  if (!announcement || !open) return null;

  return (
    <AnnouncementDialog
      announcement={announcement}
      note={announcement.repeat === 'every-start' ? 'Dieser Hinweis erscheint bei jedem Start.' : undefined}
      onClose={() => {
        rememberAnnouncementSeen(announcement);
        setOpen(false);
      }}
    />
  );
}
